import React from 'react';
import {
  loadMoreNews,
  REDUCER_NAME,
  setFilterNewValue,
  fetchListNewsData,
} from '../reducer';
import { connect } from 'react-redux';
import moment from 'moment';

import Table from '../../../common/table/Table';
import Const from './Const';
import ExpandTitle from './ExpandTitle';
import SourceSpan from './SourceSpan';
import './hidden-div.scss';
import { compose } from 'redux';
import TimeZoneHandle from '../../../common/timezone-handle';
import { listLanguage } from '../../../../configs/LanguageConfig';

const hideColumns = ['newsId'];
const sourceCode = 'sourceCode';

class TableNew extends React.PureComponent {
  constructor(props) {
    super(props);

    this.initialState = {
      pageSize: 100,
      page: 1,
      currentNewsId: null,
    };
    this.state = this.initialState;
    this.tableRef = React.createRef();
  }

  selectNewsId = currentNewsId => {
    this.setState({ currentNewsId });
  };

  loadMoreActive = () => {
    const { page } = this.state;
    const { loadMoreNews, isFetching, totalPage, filterOption } = this.props;
    if (page === totalPage || isFetching) return;
    this.setState(
      prevState => {
        return {
          page:
            prevState.page === totalPage ? prevState.page : prevState.page + 1,
        };
      },
      () => {
        const { page, pageSize } = this.state;
        loadMoreNews({
          Page: page,
          PageSize: pageSize,
          KeyWord: this.props.queryNews,
          SourceCode: filterOption.filterValue,
          ...this.props.dateRangeOption,
        });
      },
    );
  };

  componentWillReceiveProps(nextProps) {
    if (
      !this.props.dateRangeOption.FromDate &&
      nextProps.dateRangeOption.FromDate !== this.props.dateRangeOption.FromDate
    ) {
      this.resetScroll();
      this.setState({ ...this.initialState });
    }
  }

  componentDidUpdate(prevProps) {
    const { ids } = this.props;
    if (prevProps.ids.length > ids.length) {
      this.setState({ ...this.initialState });
      this.resetScroll();
    }

    const { fetchListNewsData, dateRangeOption } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      fetchListNewsData(dateRangeOption);
    }
    this.handleFilterSourceCode(prevProps);
  }

  handleFilterSourceCode = prevProps => {
    const { filterOption, dateRangeOption, fetchListNewsData } = this.props;

    if (
      prevProps.filterOption.filterKey === sourceCode &&
      !filterOption.filterKey
    ) {
      this.resetScroll();
      fetchListNewsData({
        ...dateRangeOption,
        SourceCode: null,
        Page: 1,
      });
    }

    const currentSourceCode = filterOption.filterValue;
    const prevSourceCode = prevProps.filterOption.filterValue;

    if (currentSourceCode && !prevSourceCode) {
      this.resetScroll();
      fetchListNewsData({
        ...dateRangeOption,
        SourceCode: filterOption.filterValue,
        Page: 1,
      });
    }
  };

  resetScroll = () => {
    this.tableRef.current.scrollToTop();
  };

  getDataFromRedux = state => state[REDUCER_NAME].listNewsByTicker;

  transformData = filteredIds => {
    const { list, i18n } = this.props;

    const listStartFormat = filteredIds.map(id => {
      return {
        id,
        date: moment(list[id].publicDate).format('dddd, MMMM DD, YYYY'),
      };
    });
    const groups = listStartFormat.reduce((groups, item) => {
      const date = item.date;
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(item.id);
      return groups;
    }, {});

    const format =
      i18n.locale === listLanguage.en
        ? 'dddd, MMMM DD, YYYY'
        : 'dddd, DD MMMM, YYYY';

    return Object.keys(groups)
      .map(date => {
        return {
          renderTitle: () => <TimeZoneHandle time={date} format={format} />,
          ids: groups[date],
          canToggle: true,
          date,
          rowStyle: {
            cursor: 'pointer',
          },
        };
      })
      .concat()
      .sort((a, b) => {
        if (
          moment(a.date).format('YYYY-MM-DD') >
          moment(b.date).format('YYYY-MM-DD')
        ) {
          return -1;
        }

        return 1;
      });
  };

  getIds = () => {
    const {
      filterOption: { filterKey, filterValue },
      list,
      ids,
    } = this.props;
    if (filterKey) {
      const filtedData = Object.keys(list).filter(key => {
        if (list[key][filterKey] === filterValue) return list[key][filterKey];
      });
      return this.transformData(filtedData);
    }
    return this.transformData(ids);
  };

  handleScroll = e => {
    const { page } = this.state;
    const { totalPage } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page === totalPage) return;
    if (this.props.ids.length < 50) return;
    if (bottom) {
      this.loadMoreActive();
    }
  };

  onToggleRow = () => {
    const { page } = this.state;
    const { totalPage } = this.props;
    const newPage = page + 1;
    if (
      this.tableRef.current.getClientHeight() ===
      this.tableRef.current.getScrollHeight()
    ) {
      if (newPage >= totalPage) {
        return;
      }
      this.loadMoreActive();
    }
  };

  render() {
    const { setFilterNewValue, isFetching, filterOption } = this.props;
    const { currentNewsId } = this.state;
    return (
      <div className="d-flex flex-fill px-20 mb-10">
        <Table
          onToggleRow={this.onToggleRow}
          scrollRef={this.tableRef}
          onScrollFunction={this.handleScroll}
          stickyFirstColumn={false}
          hideColumns={hideColumns}
          groups={this.getIds()}
          className="custom-table scroll-table table-striped border-table table-hover table-news w-100"
          resizable={true}
          columnDraggable={false}
          rowDraggable={false}
          getDataFromRedux={this.getDataFromRedux}
          isLoading={isFetching}
          schema={Object.keys(Const.listColumn).map(item => {
            const key = Const.listColumn[item];
            const title = `watchListNews.listTitleTable.${item}`;
            const result = {
              key,
              title,
            };

            if (key === Const.listColumn.PUBLIC_DATE) {
              return {
                disableSort: true,
                disableResize: true,
                ...result,
                thStyle: { width: '50px' },
                render: text => (
                  <div className="font-weight-light">
                    <TimeZoneHandle time={text} format={'HH:mm'} />
                  </div>
                ),
              };
            }

            if (key === Const.listColumn.TICKER) {
              return {
                ...result,
                isString: true,
                thStyle: { textAlign: 'left', width: 100 },
                tdClassName: 'text-left',
              };
            }

            if (key === Const.listColumn.NEWS_TITLE) {
              return {
                disableSort: true,
                ...result,
                thStyle: { textAlign: 'left' },
                render: (text, item, width) => {
                  return (
                    <ExpandTitle
                      width={width}
                      currentNewsId={currentNewsId}
                      item={item}
                      selectNewsId={this.selectNewsId}
                    >
                      {text}
                    </ExpandTitle>
                  );
                },
              };
            }

            if (key === Const.listColumn.NEWS_SOURCE) {
              return {
                disableSort: true,
                ...result,
                thStyle: { width: '150px', textAlign: 'center' },
                render: text => (
                  <SourceSpan
                    setFilterNewValue={setFilterNewValue}
                    text={text}
                    filterOption={filterOption}
                  />
                ),
              };
            }

            return result;
          })}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    ids: state[REDUCER_NAME].listTickerNews,
    list: state[REDUCER_NAME].listNewsByTicker,
    filterOption: state[REDUCER_NAME].filterOption,
    dateRangeOption: state[REDUCER_NAME].dateRangeOption,
    isFetching: state[REDUCER_NAME].isFetching,
    queryNews: state[REDUCER_NAME].queryNews,
    totalPage: state[REDUCER_NAME].totalPage,
    KEY_LOCAL_STORAGE: state[REDUCER_NAME].KEY_LOCAL_STORAGE,
  };
};

const mapDispatchToProps = {
  setFilterNewValue,
  loadMoreNews,
  fetchListNewsData,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(TableNew);
